'use client'

import { Button } from '@/components/v2/ui/button'
import Icon from '@/components/v2/ui/icon'
import { useTexts } from '@/contexts/LanguageContext'
import PoweredBy from './PoweredBy'

interface IErrorPageProps {
  error?: string | null
  onRetry?: () => void
  showRetry?: boolean
}

export default function ErrorPage({ error, onRetry, showRetry = true }: IErrorPageProps) {
  const { PUBLIC_TRUST_CENTER } = useTexts()
  const { ERROR } = PUBLIC_TRUST_CENTER
  return (
    <div className="flex min-h-screen flex-col bg-white text-sm text-trust-center">
      <header className="border-b border-trust-center-border">
        <div className="mx-auto flex h-20 w-full max-w-screen-2xl items-center px-4 md:px-12">
          <span className="text-xs font-medium tracking-widest text-trust-center-muted uppercase">
            {PUBLIC_TRUST_CENTER.TITLE}
          </span>
          <span className="flex-1" />
          <PoweredBy className="flex" logoClassName="bg-trust-center" />
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-16">
        <div className="flex max-w-md flex-col items-center gap-3 text-center">
          <span className="flex size-12 items-center justify-center rounded-full border border-trust-center-border-strong bg-trust-center-subtle text-trust-center-accent">
            <Icon icon="alert-circle" className="size-6" />
          </span>
          <h1 className="text-2xl font-bold tracking-tight">{ERROR.SOMETHING_WENT_WRONG}</h1>
          <p className="text-pretty text-trust-center-muted">{ERROR.DESCRIPTION}</p>
          {error && (
            <div className="flex w-full flex-col gap-1.5 rounded border border-trust-center-border bg-trust-center-subtle px-3 py-2.5 text-left">
              <span className="text-xs font-medium">{ERROR.TITLE}</span>
              <code className="text-xs break-words text-trust-center-muted">{error}</code>
            </div>
          )}
          {showRetry && onRetry && (
            <Button onClick={onRetry} className="mt-2 bg-trust-center-accent text-white hover:bg-trust-center">
              <Icon icon="refresh-outlined" className="size-4" />
              {ERROR.RETRY}
            </Button>
          )}
        </div>
      </main>
    </div>
  )
}
